import React from "react";
import Heropg from "./../components/Landing/Heropgnew";
import { About2 } from '../components/About/About2'
import {Smallform}  from '../components/Extraaddon/Smallform'
import About from "./../components/About/About";
import Medicard from "../components/Extraaddon/Medicard";



const Home = () => {
  return (
    <>
      <Heropg />
      <About2/>
      <About/>
      <Medicard/>
      <Smallform />
      
    </>
  );
};

export default Home;
